/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"


/**
 * События уведомлений
 */

/**
 * Задача на отправку СМС.
 * Очередь key.exchange.sending_sms
 */
export type SendingSmsTaskRequestDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Тип шаблона
   */
  templateKind: string
  /**
   * Назначение
   */
  destination: string
  /**
   * Переменные шаблона
   */
  templateVariables?: SendingSmsTaskTemplateVariableRequestDto[]
}
/**
 * Задача на отправку СМС.
 * Очередь key.exchange.sending_sms
 */
export type SendingSmsTaskResponseDto = {
  /**
   * Идентификатор запроса
   */
  requestId: string
  /**
   * Тип шаблона
   */
  templateKind: string
  /**
   * Назначение
   */
  destination: string
  /**
   * Переменные шаблона
   */
  templateVariables: SendingSmsTaskTemplateVariableResponseDto[]
}
/**
 * Переменные шаблона
 */
export type SendingSmsTaskTemplateVariableRequestDto = {
  /**
   * Наименование
   */
  name: string
  /**
   * Значение
   */
  value: string
}
/**
 * Переменные шаблона
 */
export type SendingSmsTaskTemplateVariableResponseDto = {
  /**
   * Наименование
   */
  name: string
  /**
   * Значение
   */
  value: string
}
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Задача на отправку СМС.
   * Очередь key.exchange.sending_sms
   */
  "SendingSmsTask": {
    "kind": "class",
    "text": "Задача на отправку СМС.\nОчередь key.exchange.sending_sms",
    "fields": {
      /**
       * Идентификатор запроса
       */
      "requestId": {
        "type": "string",
        "text": "Идентификатор запроса",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Тип шаблона
       */
      "templateKind": {
        "type": "string",
        "text": "Тип шаблона",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Назначение
       */
      "destination": {
        "type": "string",
        "text": "Назначение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Переменные шаблона
       */
      "templateVariables": {
        "type": "SendingSmsTask.TemplateVariable",
        "text": "Переменные шаблона",
      },
    },
  },
  /**
   * Переменные шаблона
   */
  "SendingSmsTask.TemplateVariable": {
    "kind": "class",
    "text": "Переменные шаблона",
    "fields": {
      /**
       * Наименование
       */
      "name": {
        "type": "string",
        "text": "Наименование",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Значение
       */
      "value": {
        "type": "string",
        "text": "Значение",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
}